import * as yup from 'yup'

export const generateBarcodeReportSchema = yup.object().shape({
  from: yup
    .string()
    .required('From date is required')
    .test('valid-from-date', 'From date must be a valid date', (value) => {
      return !isNaN(Date.parse(value || ''))
    }),
  to: yup
    .string()
    .required('To date is required')
    .test('valid-to-date', 'To date must be a valid date', (value) => {
      return !isNaN(Date.parse(value || ''))
    })
    .test('to-after-from', 'To date must be after From date', function (to) {
      const { from } = this.parent
      const fromDate = new Date(from)
      const toDate = new Date(to)
      return toDate >= fromDate
    }),
})
